module.exports = __webpack_public_path__ + "fonts/open-sans-v17-latin-600.95264708.woff2";